import { messages as communitySettingManageMessages } from '../views/system/communitySettingManageLang'
import { messages as storeInfoManageMessages } from '../views/system/storeInfoManageLang'
import { messages as publicWeChatManageMessages } from '../views/system/publicWeChatManageLang'
import { messages as smallWeChatManageMessages } from '../views/system/smallWeChatManageLang'
import { messages as paymentPoolMessages } from '../views/system/paymentPoolLang'
import { messages as operateDataLogMessages } from '../views/system/operateDataLogLang'
import { messages as historyFeeDetailImportMessages } from '../views/system/historyFeeDetailImportLang'
import { messages as feePrintSpecManageMessages } from '../views/system/feePrintSpecManageLang'
import { messages as feePrintPageManageMessages } from '../views/system/feePrintPageManageLang'
import { messages as downloadTempFileMessages } from '../views/system/downloadTempFileLang'
import { messages as assetImportLogMessages } from '../views/system/assetImportLogLang'
import { messages as assetImportLogDetailMessages } from '../views/system/assetImportLogDetailLang'
import { messages as payFeeQrcodeMessages } from '../views/fee/payFeeQrcodeLang'
import { messages as menuUserManageMessages } from '../views/system/menuUserManageLang'
import { messages as openApiAuthMessages } from '../views/system/openApiAuthLang'

export const messages = {
    en: {
        ...communitySettingManageMessages.en,
        ...storeInfoManageMessages.en,
        ...publicWeChatManageMessages.en,
        ...smallWeChatManageMessages.en,
        ...paymentPoolMessages.en,
        ...operateDataLogMessages.en,
        ...historyFeeDetailImportMessages.en,
        ...feePrintSpecManageMessages.en,
        ...feePrintPageManageMessages.en,
        ...downloadTempFileMessages.en,
        ...assetImportLogMessages.en,
        ...assetImportLogDetailMessages.en,
        ...payFeeQrcodeMessages.en,
        ...menuUserManageMessages.en,
        ...openApiAuthMessages.en,
    },
    zh: {
        ...communitySettingManageMessages.zh,
        ...storeInfoManageMessages.zh,
        ...publicWeChatManageMessages.zh,
        ...smallWeChatManageMessages.zh,
        ...paymentPoolMessages.zh,
        ...operateDataLogMessages.zh,
        ...historyFeeDetailImportMessages.zh,
        ...feePrintSpecManageMessages.zh,
        ...feePrintPageManageMessages.zh,
        ...downloadTempFileMessages.zh,
        ...assetImportLogMessages.zh,
        ...assetImportLogDetailMessages.zh,
        ...payFeeQrcodeMessages.zh,
        ...menuUserManageMessages.zh,
        ...openApiAuthMessages.zh,
    }
}